import React, { useEffect } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
import { useState } from 'react';

const AuthPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { login, loading, error, otpRequired } = useAuth();
  const [loginData, setLoginData] = useState({ email: '', password: '' });

  // Redirect to OTP verification page if OTP is required
  useEffect(() => {
    if (otpRequired) {
      navigate('/verify-otp');
    }
  }, [otpRequired, navigate]);

  const handleLoginChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const result = await login(loginData.email, loginData.password);
      // If otpRequired is true, the AuthContext will automatically update
      // and the useEffect above will redirect to OTP page
      if (!result.data.otpRequired) {
        // Old flow without 2FA (shouldn't happen with new implementation)
        navigate('/dashboard');
      }
    } catch (err) {
      // Error handled in context
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
            <img
              src="/logo.png"
              alt="KKCW Logo"
              style={{
                height: 150,
                width: 150,
                borderRadius: 8
              }}
            />
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Typography variant="h6" component="h1" sx={{ mb: 3, textAlign: 'center', fontWeight: 600 }}>
            {t('auth.login')}
          </Typography>

          {/* Login Form */}
          <Box component="form" onSubmit={handleLogin} sx={{ mt: 2 }}>
            <TextField
              label={t('auth.email')}
              name="email"
              type="email"
              value={loginData.email}
              onChange={handleLoginChange}
              fullWidth
              margin="normal"
              required
              autoFocus
            />
            <TextField
              label={t('auth.password')}
              name="password"
              type="password"
              value={loginData.password}
              onChange={handleLoginChange}
              fullWidth
              margin="normal"
              required
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 3 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : t('auth.login')}
            </Button>
          </Box>

          <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 3, textAlign: 'center' }}>
            Kasikannu Catering World
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default AuthPage;
